import axios from "axios";

import { TransferType } from "../../../types";
import { waitForBatchToBeFinished } from "../../../helpers/waitForBatchToBeFinished";

import { TransferFormContent } from "./validation";

interface Params {
  transferNumber: string;
  content: TransferFormContent;
  transferType: TransferType;
  transferId?: number;
  isStaff?: boolean;
}

export const updateTransfer = async ({
  transferNumber,
  content,
  transferType,
  transferId,
  isStaff = false,
}: Params) => {
  try {
    const res = await axios.put("transfers", {
      transferNumber,
      isWriteOff: transferType === TransferType.NonEligibleWriteOff,
      ...content,
    });

    const resp = res.data;

    if (
      isStaff &&
      transferId &&
      [TransferType.IntoProcessing, TransferType.OutOfProcessing].includes(
        transferType
      )
    ) {
      await waitForBatchToBeFinished(transferId, Date.now());
    }

    return resp;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default updateTransfer;
